import Vue from "vue";
import Router from "vue-router";
// const EditProfile = () => import('@/views/Auth/EditProfile');

import LoginPage from "@/views/Auth/Login";
import Dashboard from "@/views/Dashboard";
import DealerDashboard from "@/views/DealerDashboard";
import PageNotFound from "@/views/Error/PageNotFound";
import QRDealerStockHistory from "../views/Dashboard/QRCode/QRDealerStock/children/QRDealerStockHistory.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/edit-profile",
      name: "EditProfile",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //user dealer
    {
      path: "/territory-dealer",
      name: "TeritoryUserDealer",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //Welcome
    {
      path: "/welcome",
      name: "Welcome",
      component: Dashboard,
      meta: {
        auth: true,
      },
    },

    //highlight
    {
      path: "/highlight",
      name: "Highlight",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //   path : '/new-highlight',
    //   name : 'NewHighlight',
    //   component : Dashboard,
    //   meta : {
    //     requiresAuth : true
    //   }
    // },

    //h1
    //qr-registration
    {
      path: "/h1/qr-registration/daily",
      name: "DailyQrRegistration",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/qr-registration/Monthly",
      name: "MonthlyQrRegistration",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/qr-registration/monitoring-qr",
      name: "MonitoringQr",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    //stock-details
    {
      path: "/h1/stock-details/stock-availability",
      name: "StockAvailability",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/stock-details/stock-in-transit",
      name: "StockInTransit",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/stock-details/average-days-of-stock",
      name: "AverageDaysOfStock",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/stock-details/aging-stock",
      name: "AgingStock",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    //sales
    {
      path: "/h1/sales/regional-sales",
      name: "RegionalSales",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/sales/retail-sales",
      name: "RetailSales",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    //others
    {
      path: "/h1/warehouse-behavior/incoming",
      name: "WarehouseBehavior",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/warehouse-behavior/outgoing",
      name: "WarehouseBehaviorOutgoing",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/lead-time-delivery",
      name: "LeadTimeDelivery",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/customer-location",
      name: "CustomerLocation",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/vehicle-deviation",
      name: "VehicleDeviation",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/expedition-monitoring",
      name: "ExpeditionMonitoring",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/logistic-partner",
      name: "LogisticPartner",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/trend-sales",
      name: "TrendSales",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/mcd-report",
      name: "MCDReport",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h1/sales-territory",
      name: "SalesTerritory",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //h2
    {
      path: "/h2/qr-registration",
      name: "QrRegistration",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h2/replaced-qr",
      name: "ReplacedQr",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h2/change-ownership",
      name: "ChangeOwnership",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h2/service-cycle",
      name: "ServiceCycle",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h2/workshop-traffic",
      name: "WorkshopTraffic",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/h2/service-record",
      name: "ServiceRecord",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //report
    {
      path: "/report/h1-report",
      name: "H1Report",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/h2-report",
      name: "H2Report",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/summary-qr",
      name: "SummaryQrRegistration",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/summary-document-data",
      name: "SummaryDocumentData",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/summary-log",
      name: "SummaryLog",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/vehicle-search",
      name: "VehicleSearch",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/qrcode",
      name: "ReportQRCode",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/qrcode-replacement",
      name: "ReportQRCodeReplacement",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/change-ownership",
      name: "ReportChangeOwnership",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/customer",
      name: "Customer",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/log-report",
      name: "LogReport",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/summary-api-log",
      name: "SummaryApiLog",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/dealer-delivery",
      name: "ReportDealerDelivery",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/inv-report",
      name: "ReportInventory",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/to-report",
      name: "StatusTO",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/suggest-ring",
      name: "SuggestRing",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/crm",
      name: "ReportCRM",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/virtual-stock-expedition",
      name: "VirtualStockExpedition",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/tracking-unit",
      name: "ReportTrackingUnit",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/ssu",
      name: "ReportSSU",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/report-download",
      name: "DownloadReport",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //setting
    {
      path: "/setting/user-management",
      name: "UserManagement",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/login-history",
      name: "LoginHistory",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/target",
      name: "Target",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/dealer-radius",
      name: "DealerRadius",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/calendar",
      name: "Calendar",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/mcd-target",
      name: "MCDTarget",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/service-lost",
      name: "ServiceLostSettings",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/vehicle-type",
      name: "VehicleType",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting/location",
      name: "LocationSettings",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //QR Code
    {
      path: "/qr-code/distribution-monitoring",
      name: "DistributionMonitoring",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-issue",
      name: "QRIssue",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-issue/:id",
      name: "QRIssueDetail",
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-receipt",
      name: "QRReceipt",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer-used",
      name: "QRDealerUsed",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/transfer-amount-setting",
      alias: ["/qr-code/atur-jumlah-transfer", "/qr-code/transfer-amount"],
      name: "TransferAmountSetting",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/return-transfer-access",
      alias: ["/qr-code/atur-akses-transfer-balik"],
      name: "ReturnTransferAccess",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer-stock",
      name: "QRDealerStock",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-stock",
      name: "QRStock",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/history",
      name: "QRHistory",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/history/detail/:id",
      name: "QRHistoryIssueDetail",
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-stock/:code/send",
      name: "QRStockSend",
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-stock/:code/:issueId/edit",
      name: "QRStockEdit",
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/qr-stock/detail/:id",
      name: "QRStockIssueDetail",
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer-stock/history/:kode_dealer",
      name: "QRDealerStockHistory",
      component: Dashboard,
      props: true,
      children: [
        {
          path: "",
          component: QRDealerStockHistory,
          props: true,
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },

    //================================================//
    //            DEALER DASHBOARD START              //
    //================================================//

    //Highlight
    {
      path: "/dealer/highlight",
      name: "DealerHighlight",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //DO Pending
    {
      path: "/dealer/do-pending",
      name: "DealerDOPending",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //Tracking Unit
    {
      path: "/dealer/tracking-unit",
      name: "DealerTrackingUnit",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //QR Code
    {
      path: "/qr-code/dealer/distribution-monitoring",
      name: "DealerDistributionMonitoring",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/distribution-monitoring-se",
      name: "SeDistributionMonitoring",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer/bast-qr-md",
      name: "DealerBastQRMD",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/repeated-mapping",
      name: "RepeatedMapping",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer/qr-issue",
      name: "DealerQRIssue",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer/history",
      name: "DealerHistory",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qr-code/dealer/qr-receipt",
      name: "DealerQRReceipt",
      component: DealerDashboard,
      meta: {
        requiresAuth: true,
      },
    },

    //================================================//
    //            DEALER DASHBOARD END              //
    //================================================//

    //Error 404 Page Not Found
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
